// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type AddOptionMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type AddOptionMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { addOption?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type DeleteOptionMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  optionId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteOptionMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { deleteOption?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type PatchQuizOptionMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  quizOptionId: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.QuizOptionModelBaseInput;
}>;


export type PatchQuizOptionMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { quizOption?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'QuizOptionModelAsEditor' }
          & Pick<PrivateSchemaTypes.QuizOptionModelAsEditor, 'id'>
          & { patch: (
            { __typename?: 'QuizOptionModel' }
            & Pick<PrivateSchemaTypes.QuizOptionModel, 'id'>
          ) }
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type SetLengthMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  minLength: PrivateSchemaTypes.Scalars['NonNegativeInt'];
  maxLength: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type SetLengthMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { setLength?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type ChangeQuizTypeMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  type: PrivateSchemaTypes.TopicElementType;
}>;


export type ChangeQuizTypeMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { changeQuizType?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModelAsEditor' }
          & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);


export const AddOptionDocument = gql`
    mutation addOption($topicId: PositiveInt!, $elementId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          addOption {
            id
          }
        }
      }
    }
  }
}
    `;
export type AddOptionMutationFn = Apollo.MutationFunction<AddOptionMutation, AddOptionMutationVariables>;

/**
 * __useAddOptionMutation__
 *
 * To run a mutation, you first call `useAddOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOptionMutation, { data, loading, error }] = useAddOptionMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *   },
 * });
 */
export function useAddOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddOptionMutation, AddOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddOptionMutation, AddOptionMutationVariables>(AddOptionDocument, options);
      }
export type AddOptionMutationHookResult = ReturnType<typeof useAddOptionMutation>;
export type AddOptionMutationResult = Apollo.MutationResult<AddOptionMutation>;
export type AddOptionMutationOptions = Apollo.BaseMutationOptions<AddOptionMutation, AddOptionMutationVariables>;
export const DeleteOptionDocument = gql`
    mutation deleteOption($topicId: PositiveInt!, $elementId: PositiveInt!, $optionId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          deleteOption(optionId: $optionId) {
            id
          }
        }
      }
    }
  }
}
    `;
export type DeleteOptionMutationFn = Apollo.MutationFunction<DeleteOptionMutation, DeleteOptionMutationVariables>;

/**
 * __useDeleteOptionMutation__
 *
 * To run a mutation, you first call `useDeleteOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionMutation, { data, loading, error }] = useDeleteOptionMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      optionId: // value for 'optionId'
 *   },
 * });
 */
export function useDeleteOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOptionMutation, DeleteOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOptionMutation, DeleteOptionMutationVariables>(DeleteOptionDocument, options);
      }
export type DeleteOptionMutationHookResult = ReturnType<typeof useDeleteOptionMutation>;
export type DeleteOptionMutationResult = Apollo.MutationResult<DeleteOptionMutation>;
export type DeleteOptionMutationOptions = Apollo.BaseMutationOptions<DeleteOptionMutation, DeleteOptionMutationVariables>;
export const PatchQuizOptionDocument = gql`
    mutation patchQuizOption($topicId: PositiveInt!, $elementId: PositiveInt!, $quizOptionId: PositiveInt!, $input: QuizOptionModelBaseInput!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          quizOption(id: $quizOptionId) {
            id
            patch(input: $input) {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type PatchQuizOptionMutationFn = Apollo.MutationFunction<PatchQuizOptionMutation, PatchQuizOptionMutationVariables>;

/**
 * __usePatchQuizOptionMutation__
 *
 * To run a mutation, you first call `usePatchQuizOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchQuizOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchQuizOptionMutation, { data, loading, error }] = usePatchQuizOptionMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      quizOptionId: // value for 'quizOptionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchQuizOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PatchQuizOptionMutation, PatchQuizOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PatchQuizOptionMutation, PatchQuizOptionMutationVariables>(PatchQuizOptionDocument, options);
      }
export type PatchQuizOptionMutationHookResult = ReturnType<typeof usePatchQuizOptionMutation>;
export type PatchQuizOptionMutationResult = Apollo.MutationResult<PatchQuizOptionMutation>;
export type PatchQuizOptionMutationOptions = Apollo.BaseMutationOptions<PatchQuizOptionMutation, PatchQuizOptionMutationVariables>;
export const SetLengthDocument = gql`
    mutation setLength($topicId: PositiveInt!, $elementId: PositiveInt!, $minLength: NonNegativeInt!, $maxLength: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          setLength(minLength: $minLength, maxLength: $maxLength) {
            id
          }
        }
      }
    }
  }
}
    `;
export type SetLengthMutationFn = Apollo.MutationFunction<SetLengthMutation, SetLengthMutationVariables>;

/**
 * __useSetLengthMutation__
 *
 * To run a mutation, you first call `useSetLengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLengthMutation, { data, loading, error }] = useSetLengthMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      minLength: // value for 'minLength'
 *      maxLength: // value for 'maxLength'
 *   },
 * });
 */
export function useSetLengthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetLengthMutation, SetLengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetLengthMutation, SetLengthMutationVariables>(SetLengthDocument, options);
      }
export type SetLengthMutationHookResult = ReturnType<typeof useSetLengthMutation>;
export type SetLengthMutationResult = Apollo.MutationResult<SetLengthMutation>;
export type SetLengthMutationOptions = Apollo.BaseMutationOptions<SetLengthMutation, SetLengthMutationVariables>;
export const ChangeQuizTypeDocument = gql`
    mutation changeQuizType($topicId: PositiveInt!, $elementId: PositiveInt!, $type: TopicElementType!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          changeQuizType(type: $type) {
            id
          }
        }
      }
    }
  }
}
    `;
export type ChangeQuizTypeMutationFn = Apollo.MutationFunction<ChangeQuizTypeMutation, ChangeQuizTypeMutationVariables>;

/**
 * __useChangeQuizTypeMutation__
 *
 * To run a mutation, you first call `useChangeQuizTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeQuizTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeQuizTypeMutation, { data, loading, error }] = useChangeQuizTypeMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useChangeQuizTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeQuizTypeMutation, ChangeQuizTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeQuizTypeMutation, ChangeQuizTypeMutationVariables>(ChangeQuizTypeDocument, options);
      }
export type ChangeQuizTypeMutationHookResult = ReturnType<typeof useChangeQuizTypeMutation>;
export type ChangeQuizTypeMutationResult = Apollo.MutationResult<ChangeQuizTypeMutation>;
export type ChangeQuizTypeMutationOptions = Apollo.BaseMutationOptions<ChangeQuizTypeMutation, ChangeQuizTypeMutationVariables>;